import { ContractDetails, ContractType, InternshipDetails, JobOfferApplication, JobOfferEngagement, type JobOffer, type JobOfferFilter } from '../../api/job-offers/types'

export const filterJobOffers = (jobOffers: JobOffer[] | undefined, jobOfferApplications: JobOfferApplication[] | undefined, jobOfferEngagements: JobOfferEngagement[] | undefined, filter: Partial<JobOfferFilter>): JobOffer[] => {
  if (!jobOffers) {
    return []
  }

  return jobOffers.filter(item => {
    // Filter by text (search in title and description)
    if (filter.text) {
      const searchText = filter.text.toLowerCase()
      if (!item.title.toLowerCase().includes(searchText) &&
          !item.description.toLowerCase().includes(searchText)) {
        return false
      }
    }

    // Filter by career path
    if (filter.careerPathIds && filter.careerPathIds.length > 0 && !item.careerPaths.some(career => filter.careerPathIds?.includes(career.id.toString()))) {
      return false
    }

    // Filter by contract type
    if (filter.contractType && filter.contractType.length > 0) {
      if(!(filter.contractType.includes(ContractType.FULL_TIME) && filter.contractType.includes(ContractType.INTERNSHIP))) {
        if(filter.contractType.includes(ContractType.FULL_TIME) && item.isInternship) {
          return false
        }
        if(filter.contractType.includes(ContractType.INTERNSHIP) && !item.isInternship) {
          return false
        }
      }
    }

    // Filter by work shift
    if (item.workShiftType?.id
      && filter.workShiftIds
      && filter.workShiftIds.length > 0
      && !filter.workShiftIds?.includes(item.workShiftType.id.toString())
    ) {
      return false
    }

    // filter by contract details
    if (item.details && filter.contractDetails && filter.contractDetails.length > 0) {
      const itemDetails = item.details as InternshipDetails
      if(filter.contractDetails.includes(ContractDetails.INTERNSHIP_CURRICULAR) && !itemDetails.isCurricular) {
        return false
      }
      if(filter.contractDetails.includes(ContractDetails.INTERNSHIP_AGREEMENT) && !itemDetails.hasAgreement) {
        return false
      }
    }

    // filter by city
    if (filter.cityIds && filter.cityIds.length > 0 && !filter.cityIds?.includes(item.city?.id.toString())) {
      return false
    }

    // filter by applied
    if (filter.myJobOffers) {
      let jobOfferApplication: JobOfferApplication | undefined
      let jobOfferEngagement: JobOfferEngagement | undefined
      if(jobOfferApplications && jobOfferApplications.length > 0) {
        jobOfferApplication = jobOfferApplications.find((jobOfferApplication) => jobOfferApplication.jobOfferId === item.id)
      }
      if (jobOfferEngagements && jobOfferEngagements.length > 0) {
        jobOfferEngagement = jobOfferEngagements.find((jobOfferEngagement) => jobOfferEngagement.jobOfferId === item.id)
      }
      if (!jobOfferApplication && !jobOfferEngagement) {
        return false
      }
    }

    // filter by internal offers
    if (filter.isInternal && item.isExternal) {
      return false
    }

    return true
  })
}
